import dynamic from 'next/dynamic';

const BillingFilters = dynamic(() => import('./BillingFilters/BillingFilters'));
const BillingForm = dynamic(() => import('./BillingForm/BillingForm'));
const AddBillingTask = dynamic(() => import('./AddBillingTask/AddBillingTask'));
const BillingListContent = dynamic(() => import('./BillingListContent'));

export { BillingFilters, BillingForm, AddBillingTask, BillingListContent };
